export interface IUser {
  id: string;
  name: string;
  email: string;
  auth0Id: string;
  avatarId: string;
  userInviteId: string;
  createdAt: Date;
  updatedAt: Date;
  role: string;
  blocked: boolean;
  picture: string;
  roleLevel: number;
}

export interface IUserApiModel {
  id: string;
  name: string;
  email: string;
  auth0Id: string;
  avatarId: string;
  userInviteId: string;
  createdAt: string;
  updatedAt: string;
  role: string;
  blocked: boolean;
  picture: string;
}
export interface IUserApiModel2 {
  id: string | null;
  name: string | null;
  role: IUserRoleApi2 | null;
  email: string | null;
  blocked: boolean | null;
}

export enum IUserRoleApi2 {
  ADMIN = 'admin',
  USER = 'user',
  VIEWER = 'viewer',
  EDITOR = 'editor',
}
export interface IDocumentUserApiModel {
  id: string | null;
  name: string | null;
  picture: string | null;
}
export const roleDictionary = {
  admin: 0,
  editor: 1,
  member: 2,
  viewer: 3,
};

export const getRoleLevel = (role: string): number => {
  if (
    role === 'admin' ||
    role === 'editor' ||
    role === 'member' ||
    role === 'viewer'
  )
    return roleDictionary[role];
  return 99;
};

export default class User implements IUser {
  public readonly id: string;

  public readonly name: string;

  public readonly email: string;

  public readonly auth0Id: string;

  public readonly avatarId: string;

  public readonly userInviteId: string;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  public readonly role: string;

  public readonly blocked: boolean;

  public readonly picture: string;

  public readonly roleLevel: number;

  constructor(
    id: string,
    name: string,
    email: string,
    auth0Id: string,
    avatarId: string,
    userInviteId: string,
    createdAt: Date,
    updatedAt: Date,
    role: string,
    blocked: boolean,
    picture: string,
    roleLevel: number,
  ) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.auth0Id = auth0Id;
    this.avatarId = avatarId;
    this.userInviteId = userInviteId;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.role = role;
    this.blocked = blocked;
    this.picture = picture;
    this.roleLevel = roleLevel;
  }

  static fromApiModel(apiModel: IUserApiModel) {
    const {
      id,
      name,
      email,
      auth0Id,
      avatarId,
      userInviteId,
      role,
      blocked,
      picture,
    } = apiModel;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));
    const roleLevel = getRoleLevel(role);

    return new User(
      id,
      name,
      email,
      auth0Id,
      avatarId,
      userInviteId,
      createdAt,
      updatedAt,
      role,
      blocked,
      picture,
      roleLevel,
    );
  }

  static arrayFromApiModel(arrayApiModel: IUserApiModel[]) {
    const array = arrayApiModel.map(apiModel => User.fromApiModel(apiModel));

    return array;
  }
}
